// 本地存储封装（对齐 uni.setStorageSync 语义：自动 JSON 序列化/反序列化）

/** 写入存储
 * @param {String} key 键名
 * @param {*} value 值（任意类型）
 */
export function setStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}

/** 读取存储（未命中返回空字符串，与 uni 行为一致）
 * @param {String} key 键名
 * @returns {*} 解析后的值
 */
export function getStorage(key) {
    const raw = localStorage.getItem(key);
    if (raw === null) return '';
    try {
        return JSON.parse(raw);
    } catch (e) {
        return raw; // 非 JSON 格式原样返回
    }
}

/** 删除指定存储
 * @param {String} key 键名
 */
export function removeStorage(key) {
    localStorage.removeItem(key);
}

/** 清空全部本地存储 */
export function clearStorage() {
    localStorage.clear();
}
